export default `MARKDOWN:
  Established in 1938, Studentenes Kameraklubb boasts a rich heritage. Our 
  facilities, located at Moholt student village, are accessible to all of 
  our members. Within the premises, members can unwind on comfortable seatings, 
  engage in photography-related discussions, or utilise our desktop PC for 
  image editing purposes. Moreover, we take immense pride in our well-equipped 
  darkroom, which caters to enthusiasts interested in developing analog film. 
`;
